import styled from 'styled-components';

export const ActionButton = styled.div`
  && button {
    padding-left: 12px;
    padding-right: 12px;
    letter-spacing: 0.8px;
  }

  &.in-card {
    margin-left: 13px;

    @media screen and (max-width: 1023px) {
      order: 1;
      margin-left: 0px;
    }
  }
`;
